import * as React from 'react';

export const SlimMagnifierIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		version="1.1"
		viewBox="0 0 1200 1200"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		fill="currentColor "
	>
		<g
			fill="none"
			stroke="#059"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit="10"
			strokeWidth="2"
		>
			<path
				transform="matrix(16.318 -16.318 16.318 16.318 -203.55 491.4)"
				d="m40.588 21.294c-1.2e-4 6.8932-3.6774 13.263-9.6471 16.709s-13.325 3.4465-19.294 0-9.647-9.816-9.6471-16.709c0-6.8931 3.6776-13.263 9.6471-16.709 5.9697-3.4465 13.325-3.4465 19.294 0 5.9695 3.4467 9.6471 9.8161 9.6471 16.709"
			/>
			<path transform="scale(23.077)" d="m34.937 34.937 15.063 15.063" />
		</g>
	</svg>
);
